import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesResolutionsDefaultRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-resolutions-default',
	path: '/secure/admin/MakeDefaultResolution([!%]?[\\w]*).jspa',
};
